// StickyUnlockBar - Mobile-only fixed bottom CTA for trip unlock
// COMPACT VERSION: 56px height, single row, minimal text
// Conviction happens in modal, not here

import { useTranslation } from 'react-i18next';
import './StickyUnlockBar.css';

interface StickyUnlockBarProps {
    onUnlock: () => void;
    isVisible: boolean;
    isEligibleForLaunchPromo?: boolean;
}

export default function StickyUnlockBar({ onUnlock, isVisible, isEligibleForLaunchPromo = false }: StickyUnlockBarProps) {
    const { t } = useTranslation();

    if (!isVisible) return null;

    return (
        <div className="sticky-unlock-bar">
            {/* Single row: label + price */}
            <span className="sticky-price-text">
                {isEligibleForLaunchPromo ? (
                    <>
                        {t('unlock.sticky_compact')} · <span className="old">{t('unlock.original_trip_price')}</span> <span className="new">{t('unlock.promo_price')}</span>
                    </>
                ) : (
                    <>
                        {t('unlock.sticky_compact')} · <span className="new">{t('unlock.original_trip_price')}</span>
                    </>
                )}
            </span>
            
            <button 
                className="sticky-unlock-btn"
                onClick={onUnlock}
            >
                {t('unlock.sticky_button_short')}
            </button>
        </div>
    );
}
